export const GITHUB = "https://github.com/fshh"
export const ITCH = "https://bellisimoo.itch.io/"
export const LINKEDIN = "https://www.linkedin.com/in/belleknollmeyer/"
export const TWITTER = "https://twitter.com/belleknollmeyer"
export const RESUME = "/BelleKnollmeyerResume.pdf"
export const PLAGIARISM1 = "/BelleKnollmeyerPlagiarismReport1.pdf"
export const PLAGIARISM2 = "/BelleKnollmeyerPlagiarismReport2.pdf"
